import { render, staticRenderFns } from "./PptBgAttr.vue?vue&type=template&id=2b43fdb7&"
import script from "./PptBgAttr.vue?vue&type=script&lang=js&"
export * from "./PptBgAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b43fdb7')) {
      api.createRecord('2b43fdb7', component.options)
    } else {
      api.reload('2b43fdb7', component.options)
    }
    module.hot.accept("./PptBgAttr.vue?vue&type=template&id=2b43fdb7&", function () {
      api.rerender('2b43fdb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/PptBgAttr.vue"
export default component.exports